<template>
  <div class="overflow-hidden bg-blue-700 py-14 lg:py-28">
    <div v-for="(stack, index) in data.stacks" :key="index" class="pb-6 last:pb-0 lg:pb-24">
      <div
        v-if="index !== 0"
        class="h-[17px] w-full bg-[url(/assets/images/backgrounds/slashes-white.png)] bg-repeat"
      />
      <div class="container grid-default" :class="index === 0 ? 'pt-0' : 'pt-6 lg:pt-24'">
        <div
          class="col-span-6 flex flex-col gap-6 lg:col-span-8"
          :class="index % 2 === 0 ? 'lg:col-span-8' : 'lg:col-start-4 lg:col-end-13 lg:ml-16'"
        >
          <div ref="boxesRefs" class="h-5 w-5 rounded-full border-4 border-orange" />
          <div ref="stacksRefs" class="flex flex-col gap-8 lg:flex-row 2xl:gap-10">
            <div
              v-if="stack.heading"
              class="text-lg font-semibold text-blue-50 lg:basis-1/2 lg:text-4xl lg:font-medium"
            >
              {{ stack.heading }}
            </div>
            <div
              v-if="stack.descriptionText"
              class="text-base text-blue-200 lg:basis-1/2 lg:text-2xl"
            >
              {{ stack.descriptionText }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import type { SectionStackRecord } from '~/types/generated'

const stacksRefs = ref<HTMLElement[] | null>(null)
const boxesRefs = ref<HTMLElement[] | null>(null)
const tweenOne = ref<null | any>(null)
const tweenTwo = ref<null | any>(null)
const tweenThree = ref<null | any>(null)

defineProps({
  data: {
    type: Object as PropType<SectionStackRecord>,
    default: () => {}
  }
})

onMounted(async () => {
  await nextTick(() => {
    if (stacksRefs.value && boxesRefs.value) {
      gsap.registerPlugin(ScrollTrigger)

      gsap.utils.toArray(boxesRefs.value).forEach((layer) => {
        tweenOne.value = gsap.from(layer, {
          scrollTrigger: {
            scrub: 1,
            start: 'top-=50% center',
            end: 'top center',
            trigger: layer
          },
          x: '-100vw'
        })
      })

      gsap.utils.toArray(stacksRefs.value).forEach((layer) => {
        tweenTwo.value = gsap.from(layer.firstChild, {
          scrollTrigger: {
            scrub: 1,
            start: 'top-=50% center',
            end: 'top center',
            trigger: layer.firstChild
          },
          x: '-100vw'
        })

        tweenThree.value = gsap.from(layer.lastChild, {
          scrollTrigger: {
            scrub: 1,
            start: 'top-=50% center',
            end: 'top center',
            trigger: layer.lastChild
          },
          x: '100vw'
        })
      })
    }
  })
})

onUnmounted(() => {
  tweenOne.value?.kill()
  tweenTwo.value?.kill()
  tweenThree.value?.kill()
})
</script>
